export default __webpack_public_path__ + "static/media/9.21cd2e1d.png";